export const wrapUnprotectedHtmlTags = (content: string): string => {
  if (!content) return content;

  const codeBlockRegex = /```[\s\S]*?```/g;
  const protectedRanges: { start: number; end: number }[] = [];

  let match;
  while ((match = codeBlockRegex.exec(content)) !== null) {
    protectedRanges.push({
      start: match.index,
      end: match.index + match[0].length,
    });
  }

  const isProtected = (index: number) => {
    return protectedRanges.some(
      (range) => index >= range.start && index < range.end,
    );
  };

  const htmlTagRegex = /<html[\s\S]*?<\/html>/gi;

  return content.replace(htmlTagRegex, (matchedString, offset) => {
    if (isProtected(offset)) {
      return matchedString;
    }

    return `\n\`\`\`html\n${matchedString}\n\`\`\`\n`;
  });
};
